import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import Servicebox from "../../Components/Servicebox/Servicebox";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import CamperAuthService from "../../Api/services/CamperAuthService";
import HomeService from '../../Api/services/HomeService';
import VoucherService from "../../Api/services/VoucherService";
import PhoneInput from 'react-phone-number-input'
import ReactFlagsSelect from "react-flags-select";
import DetailService from '../../Api/services/DetailService';
import Loader from "../../Components/Loader/Loader";
import { useTranslation } from "react-i18next";
import { countries } from "../../Components/Countries/Countries";
import { Germancountries } from "../../Components/Countries/GermanCountries";
import { CountriesLabels } from "../../Components/Countries/CountriesLabels";
const VoucherCheckout = () => {
  const [phonevalue, setValue] = useState()
  var imageUrl = process.env.REACT_APP_LARAVEL_Voucher_IMAGE_URL;
  const getDetails = useLocation();
  const propsData = getDetails.state;
  const { i18n, t } = useTranslation();
  const params = useParams();
  const [skills, setSkills] = useState([]);
  const [newsletterchecked, setNewsletterchecked] = useState(false);
  const [error, setError] = useState("")
  const navigate = useNavigate();
  const [voucher, setVoucher] = useState([]);
  const [location, setLocation] = useState([]);
  const [price, setPrice] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState(null);
  const [birthdate, setBirthdate] = useState('');
  const [birtherror, setBirtherrror] = useState('');
  const [birtherror1, setBirtherrror1] = useState('');
  const [termcheck, settermcheck] = useState(false);
  const [selectedConutry, setSelectedCountry] = useState("DE");
  const [loader, setLoder] = useState(true);
  const [ActiveTab, setActiveTab] = useState("Private");
  useEffect(() => {
    var id = params.id;
    getVoucherByID(id);
    getLocation();
    let dateRange = propsData.date
    if (dateRange) {
      var dateSelected = dateRange.split("_");
      setStartDate(dateSelected[0])
      setEndDate(dateSelected[1])
    }

  }, []);
  const getVoucherByID = async (id) => {
    try {
      let getVoucher = await VoucherService.show(id).json();
      //  console.log();
      setVoucher(getVoucher.data);
      setLoder(false);
      let price = getVoucher.data.camper_price[0].price

      setPrice(price);

    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };
  const handleNewsletterChange = () => {
    setNewsletterchecked(!newsletterchecked);
  };
  const getLocation = async () => {
    try {
      let locationList = await HomeService.location().json();
      setLocation(locationList.data);
      let getdata = locationList.data.filter(function (item) {
        return item.id == propsData.location;
      });
      setSkills(getdata);
    } catch (error) {
      console.log(error);
    }
  };
  const detailData = {
    location: propsData.location,
    date: propsData.date,
    pickup: propsData.pickup,
    return: propsData.return,
    packages: propsData.packages,
    serviceFee: propsData.serviceFee,
    days: propsData.days,
    totalPackages: parseInt(propsData.totalPackages),
    camperPrice: price,
    title: voucher.title,
    id: voucher.id
  }
  const handleBirthdate = (e) => {

    let input = e.target.value;

    // Remove any non-digit characters
    input = input.replace(/\D/g, '');

    // Format the date as dd/mm/yyyy
    if (input.length <= 2) {
      setBirthdate(input);
    } else if (input.length <= 4) {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2)}`);
    } else {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`);

    }

    const currentYear = new Date().getFullYear();
    const year = e.target.value.split("/")[2];
    const month = e.target.value.split("/")[1];
    const day = e.target.value.split("/")[0];
    const age = currentYear - year;
    if (month >= 13 || age < 21 || day >= 32) {
      setBirtherrror(t("Rent.You have to be at least 21 years old"));
    }
    else {
      setBirtherrror("");
    }



  }
  const handleBirthdate1 = (e) => {
    let input = e.target.value;

    // Remove any non-digit characters
    input = input.replace(/\D/g, '');

    // Format the date as dd/mm/yyyy
    if (input.length <= 2) {
      setBirthdate(input);
    } else if (input.length <= 4) {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2)}`);
    } else {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`);
    }
    const currentYear = new Date().getFullYear();
    const year = e.target.value.split("/")[2];
    const month = e.target.value.split("/")[1];
    const day = e.target.value.split("/")[0];
    const age = currentYear - year;
    if (month >= 13 || age < 21 || day >= 32) {
      setBirtherrror(t("Rent.You have to be at least 21 years old"));
    }
    else {
      setBirtherrror1("");
    }

  }
  const onSubmitForm = async (event) => {

    event.preventDefault();
    setError("")
    if (event.target.name.value === "") {
      setError(t("Rent.Your name is missing. Please enter your full name."));
    }
    else if (event.target.email.value === "") {

      setError(t("Rent.Please enter your email address to proceed."));
    }
    else if (event.target.phone.value === "") {

      setError(t("Rent.Please enter your phone number to proceed."));
    }
    else if (birthdate === "") {

      setError(t("Rent.Please enter your date of birth to complete the booking process."));
    }
    else if (event.target.street.value === "") {

      setError(t("Rent.The street address is missing. Please enter your street address."));
    }
    else if (event.target.zip.value === "") {

      setError(t("Rent.The postal code is missing. Please enter your postal code."));
    }
    else if (event.target.city.value === "") {

      setError(t("Rent.The city is missing. Please enter your city."));
    }
    else if (birtherror != "" || birtherror != "") {
      setBirtherrror("")
      setError(t("Rent.You have to be at least 21 years old"));
    }
    else if (ActiveTab === "Company" ? event.target.company_name.value === "" :"") {
      
      setError(t("Rent.Please enter your company name to proceed."));
    }
    else if (ActiveTab === "Company" ? event.target.vat_id.value === "" :"") {
      setError(t("Rent.The VAT-ID is missing. Please enter it."));

    }
    else{

     
    try {
     
      var userData = {
        "name": event.target.name.value,
        "email": event.target.email.value,
        "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
        "phone": phonevalue,
        "address_addition": event.target.address.value,
        "street": event.target.street.value,
        "zip": event.target.zip.value,
        "city": event.target.city.value,
        "country": selectedConutry ? selectedConutry : '',
        "company": event.target.company_name ? event.target.company_name.value : '',
        "vat_id": event.target.vat_id ? event.target.vat_id.value : '',
        "status": 0,
        "user_id": "",
        'is_newsletter': newsletterchecked ? 1 : 0,
        "lng": i18n.resolvedLanguage,
        "booking_type": "Voucher Booking"
      }
     
     
      let responseData = await DetailService.store(userData).json()
      if (responseData.status === true) {

        localStorage.setItem("payment_status_voucher", 1);
        navigate(`/voucher-payment`, {
          state:
          {
            userData: userData,
            price: propsData,
            voucher: voucher,
            user_id: ""
          }
        });
      }
      // if (localStorage.getItem('usertoken')) {
      //   const userd = JSON.parse(localStorage.getItem('user'));
      //   var userData = {
      //     "name": event.target.name.value,
      //     "email": event.target.email.value,
      //     "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //     "phone": phonevalue,
      //     "address_addition": event.target.address.value,
      //     "street": event.target.street.value,
      //     "zip": event.target.zip.value,
      //     "city": event.target.city.value,
      //     "country": selectedConutry ? selectedConutry : '',
      //     "company": event.target.company ? event.target.company.value : '',
      //     "vat_id": event.target.vat_id ? event.target.vat_id.value : '',
      //     "status": 0,
      //     "user_id": userd.id,
      //     'is_newsletter': newsletterchecked ? 1 : 0
      //   }
      //   let responseData = await DetailService.store(userData).json()
      //   if (responseData.status === true) {

      //     localStorage.setItem("payment_status_voucher", 1);
      //     navigate(`/voucher-payment`, {
      //       state:
      //       {
      //         userData: userData,
      //         price: propsData,
      //         voucher: voucher,
      //         user_id: userd.id
      //       }
      //     });
      //   }
      // } else {

      //   var registerdata = {
      //     "name": event.target.name.value,
      //     "email": event.target.email.value,
      //     "password": "password",
      //     "phone": phonevalue,
      //     "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //     "address_addition": event.target.address.value,
      //     "street": event.target.street.value,
      //     "zip": event.target.zip.value,
      //     "city": event.target.city.value,
      //     "country": selectedConutry ? selectedConutry : '',
      //     "company": event.target.company ? event.target.company.value : '',
      //     "vat_id": event.target.vat_id ? event.target.vat_id.value : '',
      //     "status": 0,
      //     'is_newsletter': newsletterchecked ? 1 : 0
      //   }
      //   let registrationData = await CamperAuthService.register(registerdata).json();
      //   if (registrationData.status === true) {
      //     var userData = {
      //       "name": event.target.name.value,
      //       "email": event.target.email.value,
      //       "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //       "phone": phonevalue,
      //       "address_addition": event.target.address.value,
      //       "street": event.target.street.value,
      //       "zip": event.target.zip.value,
      //       "city": event.target.city.value,
      //       "country": selectedConutry ? selectedConutry : '',
      //       "company": event.target.company ? event.target.company.value : '',
      //       "vat_id": event.target.vat_id ? event.target.vat_id.value : '',
      //       "status": 0,
      //       "user_id": registrationData.user_id,
      //       'is_newsletter': newsletterchecked ? 1 : 0
      //     }

      //     let responseData = await DetailService.store(userData).json()
      //     if (responseData.status === true) {
      //       console.log(userData, "registerdata")
      //       localStorage.setItem("payment_status_voucher", 1);
      //       navigate(`/voucher-payment`, {
      //         state:
      //         {

      //           userData: userData,
      //           price: propsData,
      //           voucher: voucher,

      //           user_id: registrationData.user_id
      //         }
      //       });
      //     }
      //   }
      // }
      // if (localStorage.getItem('usertoken')) {
      //   const userd = JSON.parse(localStorage.getItem('user'));

      //   var userData = {
      //     "voucher_id": params.id,
      //     "voucher_code": Math.random().toString(36).substr(2, 9),
      //     "order_id": 0,
      //     "price": 0,
      //     "first_last_name": event.target.name.value,
      //     "email": event.target.email.value,
      //     "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //     "phone": phonevalue,
      //     "address_addition": event.target.address.value,
      //     "street": event.target.street.value,
      //     "zip_code": event.target.zip.value,
      //     "city": event.target.city.value,
      //     "country": selectedConutry ? selectedConutry : '',
      //     "company_name": event.target.company_name ? event.target.company_name.value : "",
      //     "vat_id": event.target.vat_id ? event.target.vat_id.value : "",
      //     "user_id": userd.id,
      //     'is_newsletter': newsletterchecked ? 1 : 0
      //   }
      //   let responseData = await DetailService.store(userData).json()
      //   if (responseData.status === true) {

      //     localStorage.setItem("payment_status_voucher", 1);
      //     navigate("/voucher-payment", {
      //       state:
      //       {
      //         userData: userData,
      //         price: propsData,
      //         voucher: voucher,
      //         user_id: userd.id
      //       }
      //     });
      //   }


      //   /*let responseData = await VoucherService.store(userData).json()
      //   if (responseData.status === true) {
      //     navigate("/voucher-payment", {
      //       state:
      //       {
      //         userData: responseData,
      //         price: propsData,
      //         voucher: voucher
      //       }
      //     });
      //   }*/
      // } else {
      //   var registerdata = {
      //     // "name": event.target.name.value,
      //     // "email": event.target.email.value,
      //     // "password": "password",
      //     // "phone": event.target.phone.value,
      //     // "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //     "name": event.target.name.value,
      //     "email": event.target.email.value,
      //     "password": "password",
      //     "phone": phonevalue,
      //     "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //     "address_addition": event.target.address.value,
      //     "street": event.target.street.value,
      //     "zip": event.target.zip.value,
      //     "city": event.target.city.value,
      //     "country": selectedConutry ? selectedConutry : '',
      //     "company": event.target.company ? event.target.company.value : '',
      //     "vat_id": event.target.vat_id ? event.target.vat_id.value : '',
      //     "status": 0,
      //     'is_newsletter': newsletterchecked ? 1 : 0

      //   }
      //   let registrationData = await CamperAuthService.register(registerdata).json();
      //   if (registrationData.status === true) {
      //     var userData = {
      //       "voucher_id": params.id,
      //       "voucher_code": Math.random().toString(36).substr(2, 9),
      //       "order_id": 0,
      //       "price": 0,
      //       "first_last_name": event.target.name.value,
      //       "email": event.target.email.value,
      //       "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
      //       "phone": phonevalue,
      //       "address_addition": event.target.address.value,
      //       "street": event.target.street.value,
      //       "zip_code": event.target.zip.value,
      //       "city": event.target.city.value,
      //       "country": selectedConutry ? selectedConutry : '',
      //       "company_name": event.target.company_name ? event.target.company_name.value : "",
      //       "vat_id": event.target.vat_id ? event.target.vat_id.value : "",
      //       "user_id": registrationData.user_id,
      //       'is_newsletter': newsletterchecked ? 1 : 0
      //     }
      //     let responseData = await DetailService.store(userData).json()
      //     if (responseData.status === true) {

      //       localStorage.setItem("payment_status_voucher", 1);
      //       navigate("/voucher-payment", {
      //         state:
      //         {
      //           userData: userData,
      //           price: propsData,
      //           voucher: voucher,
      //           user_id: registrationData.user_id
      //         }
      //       });
      //     }


      //     /*let responseData = await VoucherService.store(userData).json()
      //     if (responseData.status === true) {

      //       navigate("/voucher-payment", {
      //         state:
      //         {
      //           userData: responseData,
      //           price: propsData,
      //           voucher: voucher
      //         }
      //       });
      //     }
      //     setError(responseData.message)*/
      //   }
      // }

    } catch (error) {

      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        {
          i18n.resolvedLanguage === 'de' ?
            setError(t("Rent.Please Sign in under") + " " + `"` + t("Rent.Login") + `"` + " " + t("Rent.then you can make a new Booking with your Email Address"))
            :
            setError(t("Rent.Please Sign in under") + " " + t("Rent.Login") + " " + t("Rent.then you can make a new Booking with your Email Address"))

        }
      }

    }
  }
  };
  return (
    <>
      <div className="relative flex flex-col min-h-screen font-brand pb-16 xl:pb-0 bg-off-white">
        <Header />
        <main className="flex-grow pt-100 mt-5">

          <div className="w-full max-w-5xl xl:flex mx-auto detail-width">
            <div className="ml-3 mr-3 xl:block xl:w-1/2 md:mt-5 mt-0 md:pt-1 pt-0">
              {loader ? <Loader /> :
                <>
                  <div className="aspect-w-2 aspect-h-1 w-full">
                    <img
                      className="top-radius -mb-8 w-full h-full object-contain object-bottom"
                      src={imageUrl + voucher.voucher_image}
                      alt="side-detail-img"
                    />
                  </div>
                  <div className="bg-white rounded-button shadow rounded-none divide-secondary divide-opacity-disabled divide-y overflow-hidden rounded -mt-10 pt-10 divide-y-0">
                    <div className="flex flex-col items-center p-6">
                      <span className="fw-500 text-center"></span>
                      <h3 className="fw-500 break-words text-3xl text-center">
                        {voucher.title}
                      </h3>
                      <span className="mb-1 mt-2 text-md text-primary text-orange block text-18">{t("Rent.Price")}: {propsData}€</span>
                    </div>
                  </div>
                </>
              }
            </div>

            <form
              onSubmit={onSubmitForm}
              className="mx-auto p-10 max-w-xl xl:w-1/2 company-tab-list pt-2"
            >
              <div className="text-center fw-500 mt-2 w-full mb-4 text-3xl text-lg mt-4 mb-16">
                {t("Rent.Personal details")}
              </div>
              <Tabs>
                <TabList>
                  <Tab  onClick={(key) => setActiveTab('Private')}><span className="fw-500">{t("Rent.Private")}</span></Tab>
                  <Tab onClick={(key) => setActiveTab('Company')}><span className="fw-500">{t("Rent.Company")}</span></Tab>


                </TabList>
                <TabPanel>
                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("sale.First & Last Name*")}</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="name"
                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-person">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 14.6527C13.6105 14.6527 11.6736 12.7158 11.6736 10.3264C11.6736 7.93688 13.6105 6 16 6C18.3895 6 20.3264 7.93688 20.3264 10.3264C20.3264 12.7158 18.3895 14.6527 16 14.6527Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.1565 15.9742C12.2188 15.8883 9 19.0545 9 22.9726C9 23.4621 9.05258 23.9383 9.15042 24.3979C9.26224 24.9247 9.72616 25.3021 10.2643 25.3021H21.7361C22.2693 25.3021 22.7352 24.9324 22.847 24.4112C23.0091 23.6528 23.05 22.8501 22.9329 22.0181C22.4596 18.6482 19.5587 16.0487 16.1565 15.9742Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("sale.Email")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="email" name="email"
                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-email">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.476 27.333C17.811 27.333 20.088 26.229 20.088 25.677C20.088 25.286 19.743 24.389 19.421 24.205C18.34 24.757 16.523 25.263 14.89 25.263C10.566 25.263 7.277 22.112 7.277 16.868C7.277 13.073 10.037 7.162 17.144 7.162C22.871 7.162 24.504 11.095 24.504 13.694C24.504 17.834 22.595 19.904 20.824 19.904C20.088 19.904 19.628 19.467 19.628 18.409C19.628 18.1985 19.6547 17.7412 19.6937 17.2562L19.7298 16.8388C19.7554 16.5629 19.7837 16.2983 19.812 16.086L20.479 11.992C20.226 11.67 19.007 11.509 18.363 11.532C18.3496 11.6393 18.2892 11.958 18.2275 12.3099L18.1754 12.6155C18.1502 12.7682 18.1273 12.9178 18.11 13.05C17.811 12.268 17.029 11.256 15.557 11.256C13.648 11.256 11.026 13.027 11.026 16.937C11.026 19.398 12.314 21.353 14.637 21.353C16.063 21.353 17.052 20.502 17.696 19.605H17.834C18.064 20.824 19.076 21.951 20.732 21.951C23.492 21.951 26.689 19.375 26.689 13.74C26.689 8.358 22.641 5 17.259 5C8.887 5 5 11.486 5 16.96C5 22.848 9.094 27.333 14.476 27.333ZM15.143 19.168C14.223 19.168 13.349 18.524 13.349 16.891C13.349 15.074 14.085 13.395 15.787 13.395C16.776 13.395 17.443 14.476 17.443 15.902C17.443 18.041 16.247 19.168 15.143 19.168Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>



                  <div className="p-2 fw-500">{t("Rent.Phone Number")} *</div>
                  <div className="checkout-call relative z-foreground mb-4 flex h-[50px] items-center rounded border bg-white text-black transition-all focus-within:border-primary focus:border-primary dark:bg-off-black-desat dark:text-off-white dark:focus-within:border-primary-dark border-transparent">
                    <div className="peer flex w-full flex-col">
                      {/* <input
                        className="peer w-full rounded bg-transparent pb-1 pl-6 text-md outline-none focus:pr-6 pr-6"
                        type="tel" name="phone"
                      /> */}
                      <PhoneInput
                        placeholder={t("Rent.Enter phone number")}
                        className="peer w-full rounded bg-transparent pb-1 pl-6 text-md outline-none focus:pr-6 pr-6"
                        value={phonevalue}
                        onChange={setValue}
                        name="phone"
                      />
                      <label
                        className="pointer-events-none absolute ml-12 origin-left translate-y-[15px] scale-100 cursor-text select-none text-md transition-all peer-focus-within:translate-y-1 peer-focus-within:scale-75 peer-focus-within:opacity-50"
                        htmlFor=""
                      >

                      </label>
                    </div>
                  </div>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Date of birth")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text"
                        value={birthdate}
                        placeholder={t("Rent.DD/MM/YYYY")} name="dob" onChange={handleBirthdate}
                      />

                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div> {birtherror ? <p style={{ color: "red" }} >{birtherror}</p> : ''}
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Street")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="street"
                      />
                      <svg className="w7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-location">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Address addition")}</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="address"
                      />
                      <svg className="w7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-location">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <div className="grid gap-4 grid-cols-3">
                    <label htmlFor="" className="flex flex-col">
                      <div className="p-2 fw-500">{t("Rent.Zip")} *</div>
                      <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                        <input
                          className="w-full h-full font-light outline-none"
                          type="text" name="zip"
                        />
                        <svg className="w7 h-7" width="32" height="32">
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-location"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>
                      </div>
                      <div className="px-4 py-1 xl:h-6 font-light"></div>
                    </label>

                    <label className="flex flex-col col-span-2" htmlFor="">
                      <div className="p-2 fw-500">{t("Rent.City")} *</div>
                      <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                        <input
                          className="w-full h-full font-light outline-none"
                          type="text" name="city"
                        />
                        <svg className="w7 h-7" width="32" height="32">
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-location"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>
                      </div>
                    </label>
                  </div>

                  <div className="country-flag-wrapper mb-5">
                    <label className="flex flex-col" htmlFor="">
                      <div className="p-2 fw-500">{t("Rent.Country")}</div>

                      <ReactFlagsSelect
                        countries={CountriesLabels}
                        customLabels={i18n.resolvedLanguage === 'de' ? Germancountries : countries}
                        showOptionLabel={true}
                        selected={selectedConutry}
                        onSelect={(code) => setSelectedCountry(code)}
                        className="flag-container flex items-center justify-around px-4 py-2 h-11 bg-white focus-within:border focus-within:border-primary rounded-t-xl hover:shadow rounded-b-xl"
                        selectButtonClassName="w7 h-7"
                        id="icon-location"
                        searchable

                      />

                    </label>

                  </div>
                  {error ? <p style={{ color: "red" }} className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white">{error}</p> : ''}
                  <div className="mt-2 fw-500">*{t("Rent.Required field")}</div>
                  <label className="flex items-center font-size-reduce-mobile">
                    <div className="mr-4 w-7 h-7">
                      <input id="newsletter" type="checkbox" onChange={() => handleNewsletterChange()} hidden="" name="currentInformation" className="peer custom-checkbox-input" />
                      <label htmlFor="" className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"></label>
                      <svg className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-check"><path fillRule="evenodd" clipRule="evenodd" d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                    </div>
                    <span className="fw-500">{t("Rent.Yes, I would like to receive current information")} {t("Rent.offers about camping")}</span>
                  </label>
                  {
                    termcheck === false ?
                      <label className="group flex items-center mt-4 font-size-reduce-mobile font-size-reduce-mobile" htmlFor="">
                        <div className="w-7 h-7">
                          <input
                            id="checkbox-terms"
                            type="checkbox"
                            hidden=""
                            name="terms"
                            onChange={() => settermcheck(termcheck ? false : true)}
                            checked={termcheck}
                            required
                            className="peer custom-checkbox-input"
                          />
                          <label
                            htmlFor="checkbox-terms"
                            className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"
                          ></label>
                          <svg
                            className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full"
                            width="32"
                            height="32"
                          >
                            <svg viewBox="0 0 32 32" fill="none" id="icon-check">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                        </div>
                        <div className="ml-4 font-size-reduce-mobile">
                          <span>{t("Rent.I have read and agree to the")} </span>
                          <Link to="/privacystatement" className="underline">{t("Rent.Privacy Policy")}</Link>
                          <span> {t("Rent.and the")} </span>
                          <Link to="/gtc" className="underline d-block-mobile">{t("Rent.Terms and Conditions")}</Link>
                          &nbsp;
                          <span>{t("Rent.conditions")}</span>
                        </div>
                      </label>
                      :
                      <label className="group flex items-center mt-4 font-size-reduce-mobile" htmlFor="">
                        <div className="w-7 h-7">
                          <input
                            id="checkbox-terms"
                            type="checkbox"
                            hidden=""
                            name="terms"
                            onChange={() => settermcheck(termcheck ? false : true)}
                            checked={termcheck}

                            className="peer custom-checkbox-input"
                          />
                          <label
                            htmlFor="checkbox-terms"
                            className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"
                          ></label>
                          <svg
                            className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full"
                            width="32"
                            height="32"
                          >
                            <svg viewBox="0 0 32 32" fill="none" id="icon-check">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                        </div>
                        <div className="ml-4 font-size-reduce-mobile">
                          <span>{t("Rent.I have read and agree to the")} </span>
                          <Link to="/privacystatement" className="underline">{t("Rent.Privacy Policy")}</Link>
                          <span> {t("Rent.and the")} </span>
                          <Link to="/gtc" className="underline d-block-mobile">{t("Rent.Terms and Conditions")}</Link>
                          &nbsp;
                          <span>{t("Rent.conditions")}</span>
                        </div>
                      </label>
                  }

                  <button
                    type="submit"
                    className="mt-5 grid-cols1 inline-grid grid-rows-1 text-white bg-secondary hover:bg-primary pl-5 pr-2 w-full h-12 rounded bg-primary hover:bg-secondary transition-all btn btn-primary"
                  >
                    <span className="relative flex col-start-1 row-start-1 items-center justify-between w-full h-full transition-opacity duration-300">
                      <span className="transform transition-transform duration-300 translate-x-0">
                        <span >{t("Rent.Continue to Payment")}</span>
                      </span>
                      <svg
                        className="w-7 h-7 cssvar-secondary-to-white pointer-events-none"
                        width="32"
                        height="32"
                      >
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          id="icon-chevron-right"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M22.1256 15.9999L14.479 8.35332C14.009 7.88273 13.2445 7.88213 12.7739 8.35211L12.3532 8.77342C11.8809 9.24581 11.8833 10.0073 12.3544 10.4785L17.8759 15.9999L12.3544 21.5219C11.8833 21.9925 11.8809 22.7546 12.3532 23.2264L12.7739 23.6477C13.2445 24.1182 14.009 24.117 14.479 23.6465L22.1256 15.9999Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </span>
                  </button>

                  {/* <div className="error-text text-center mt-2"> {error} </div> */}
                </TabPanel>
                <TabPanel>
                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("sale.First & Last Name*")}</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="name"

                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-person">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 14.6527C13.6105 14.6527 11.6736 12.7158 11.6736 10.3264C11.6736 7.93688 13.6105 6 16 6C18.3895 6 20.3264 7.93688 20.3264 10.3264C20.3264 12.7158 18.3895 14.6527 16 14.6527Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.1565 15.9742C12.2188 15.8883 9 19.0545 9 22.9726C9 23.4621 9.05258 23.9383 9.15042 24.3979C9.26224 24.9247 9.72616 25.3021 10.2643 25.3021H21.7361C22.2693 25.3021 22.7352 24.9324 22.847 24.4112C23.0091 23.6528 23.05 22.8501 22.9329 22.0181C22.4596 18.6482 19.5587 16.0487 16.1565 15.9742Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("sale.Email")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="email" name="email"

                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-email">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.476 27.333C17.811 27.333 20.088 26.229 20.088 25.677C20.088 25.286 19.743 24.389 19.421 24.205C18.34 24.757 16.523 25.263 14.89 25.263C10.566 25.263 7.277 22.112 7.277 16.868C7.277 13.073 10.037 7.162 17.144 7.162C22.871 7.162 24.504 11.095 24.504 13.694C24.504 17.834 22.595 19.904 20.824 19.904C20.088 19.904 19.628 19.467 19.628 18.409C19.628 18.1985 19.6547 17.7412 19.6937 17.2562L19.7298 16.8388C19.7554 16.5629 19.7837 16.2983 19.812 16.086L20.479 11.992C20.226 11.67 19.007 11.509 18.363 11.532C18.3496 11.6393 18.2892 11.958 18.2275 12.3099L18.1754 12.6155C18.1502 12.7682 18.1273 12.9178 18.11 13.05C17.811 12.268 17.029 11.256 15.557 11.256C13.648 11.256 11.026 13.027 11.026 16.937C11.026 19.398 12.314 21.353 14.637 21.353C16.063 21.353 17.052 20.502 17.696 19.605H17.834C18.064 20.824 19.076 21.951 20.732 21.951C23.492 21.951 26.689 19.375 26.689 13.74C26.689 8.358 22.641 5 17.259 5C8.887 5 5 11.486 5 16.96C5 22.848 9.094 27.333 14.476 27.333ZM15.143 19.168C14.223 19.168 13.349 18.524 13.349 16.891C13.349 15.074 14.085 13.395 15.787 13.395C16.776 13.395 17.443 14.476 17.443 15.902C17.443 18.041 16.247 19.168 15.143 19.168Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  {/* <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">Phone *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="phone"

                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-phone">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.0035 8.13854C11.8329 7.56996 11.6624 7.11509 11.0938 7.05824L10.0135 7.00138C8.87632 6.94452 7 8.65026 7 11.4932C7.05686 16.4398 14.4484 24.5137 19.3382 24.9686C22.238 25.2529 24.0575 23.5471 24.1143 22.3531V21.3296C24.1712 20.7611 23.7163 20.5336 23.1477 20.3062C22.0674 19.9082 20.9871 19.3965 19.9068 18.9985C19.4519 18.8279 19.0539 19.1122 18.7696 19.2827C18.3716 19.6239 18.0873 19.8513 17.7462 20.2493C17.4619 20.4768 17.1776 20.5905 16.8933 20.3062C14.4484 19.0553 12.4584 16.8947 11.4349 14.3929C11.2075 14.0518 11.3212 13.7675 11.6055 13.5401C12.0035 13.1989 12.2878 12.9146 12.629 12.5735C12.8564 12.346 13.1407 11.948 13.027 11.4932C12.6858 10.4129 12.3447 9.21885 12.0035 8.13854Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 md:h-6 font-light"></div>
                  </label> */}

                  <div className="p-2 fw-500">{t("Rent.Phone Number")} *</div>
                  <div className="checkout-call relative z-foreground mb-4 flex h-[50px] items-center rounded border bg-white text-black transition-all focus-within:border-primary focus:border-primary dark:bg-off-black-desat dark:text-off-white dark:focus-within:border-primary-dark border-transparent">
                    <div className="peer flex w-full flex-col">
                      {/* <input
                        className="peer w-full rounded bg-transparent pb-1 pl-6 text-md outline-none focus:pr-6 pr-6"
                        type="tel" name="phone"
                      /> */}
                      <PhoneInput
                        placeholder={t("Rent.Enter phone number")}
                        className="peer w-full rounded bg-transparent pb-1 pl-6 text-md outline-none focus:pr-6 pr-6"
                        value={phonevalue}
                        onChange={setValue}
                        name="phone"
                      />
                      <label
                        className="pointer-events-none absolute ml-12 origin-left translate-y-[15px] scale-100 cursor-text select-none text-md transition-all peer-focus-within:translate-y-1 peer-focus-within:scale-75 peer-focus-within:opacity-50"
                        htmlFor=""
                      >

                      </label>
                    </div>
                  </div>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Date of birth")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text"
                        value={birthdate}
                        placeholder={t("Rent.DD/MM/YYYY")} name="dob" onChange={handleBirthdate1}
                      />
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>{birtherror1 ? <p style={{ color: "red" }} >{birtherror1}</p> : ''}
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Company")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="company_name"
                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        {" "}
                        <svg viewBox="0 0 32 32" fill="none" id="icon-home">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M13.2098 24.0325H9.63772C9.34738 24.0325 9.11202 23.7971 9.11202 23.5068V14.9204H7.5257C7.23536 14.9204 7 14.685 7 14.3947C7 14.2485 7.06087 14.1089 7.16799 14.0095L15.6423 6.14047C15.844 5.95318 16.156 5.95318 16.3577 6.14047L24.832 14.0095C25.0448 14.207 25.0571 14.5396 24.8595 14.7524C24.7601 14.8595 24.6205 14.9204 24.4743 14.9204H22.888V23.5068C22.888 23.7971 22.6526 24.0325 22.3623 24.0325H18.7902C18.4999 24.0325 18.2645 23.7971 18.2645 23.5068V17.3444C18.2645 17.0541 18.0292 16.8187 17.7388 16.8187H14.2612C13.9708 16.8187 13.7355 17.0541 13.7355 17.3444V23.5068C13.7355 23.7971 13.5001 24.0325 13.2098 24.0325Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.VAT-ID")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="vat_id"
                      />
                      <svg className="w-7 h-7" width="32" height="32">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 32 32"
                          fill="none"
                          id="icon-hashtag"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.7554 7L15.8711 7.00356C15.9434 7.00683 16.0064 7.01195 16.0609 7.01937C16.1248 7.02808 16.1808 7.03999 16.2379 7.06074C16.3939 7.1175 16.5243 7.21502 16.5545 7.39488L16.5606 7.48928L16.5438 7.59926L16.3792 8.30348L15.3482 12.4114L16.5277 12.3949L18.4545 12.3463L18.6027 11.7046L18.8852 10.3873L19.4321 7.66438L19.462 7.48906C19.5177 7.24149 19.6548 7.17656 19.8856 7.12354C19.9544 7.10774 20.0349 7.09634 20.1324 7.08693C20.2088 7.07957 20.297 7.07338 20.3966 7.06822L20.7287 7.05567C20.9609 7.04947 21.2041 7.04685 21.4599 7.04662L21.9554 7.04865L22.2927 7.25633L22.3848 7.31941L22.4373 7.36521C22.4609 7.39163 22.4638 7.4115 22.4573 7.4347L22.442 7.47324L22.44 7.553L22.419 7.69824L22.3861 7.86573L22.1182 9.01044L21.4355 11.7887L21.324 12.2743L21.8054 12.2698L22.6094 12.2743L22.9725 12.2818L23.1286 12.2869C23.2198 12.2904 23.299 12.2943 23.3659 12.2989L23.457 12.3062C23.5111 12.3113 23.556 12.3172 23.5976 12.3257C23.8813 12.3841 24 12.4346 24 12.7559L23.9813 12.9841L23.8923 13.7412L23.8358 14.1427L23.8006 14.3557C23.7893 14.4185 23.7784 14.473 23.7676 14.5198L23.7514 14.5842C23.7416 14.6183 23.7341 14.6425 23.7251 14.6656L23.7101 14.7004C23.6278 14.877 23.5374 14.9839 23.2492 14.9839L20.7118 14.9419L20.2995 16.5796L19.9378 18.0407L20.5821 18.0487L21.205 18.0626L21.5689 18.0753L21.8706 18.0908C21.9155 18.0936 21.9577 18.0966 21.997 18.0997C22.1155 18.109 22.2102 18.1195 22.2854 18.1328C22.343 18.1431 22.3928 18.1552 22.4431 18.174C22.6227 18.2414 22.7602 18.3473 22.7602 18.5865L22.726 19.4578L22.6996 19.896L22.6832 20.0878L22.6678 20.2114L22.6567 20.2701C22.6543 20.2799 22.6511 20.2922 22.6464 20.3107L22.6535 20.3417C22.6545 20.3558 22.6504 20.3685 22.6353 20.384L22.5886 20.4201L22.5021 20.4709L22.1678 20.6466L21.3035 20.643L20.2362 20.6462L19.5426 20.6585L19.4816 20.6603L19.2108 21.7471L18.4363 24.9707L17.4019 24.9545L16.8855 24.9416L16.4203 24.924L16.2462 24.9136L16.14 24.9039L16.0722 24.8945L16.0366 24.8914L15.9956 24.8772L15.7933 24.7681C15.7487 24.7284 15.7353 24.5809 15.7445 24.361L15.7608 24.1184L15.7904 23.8355L15.8312 23.5204L15.8814 23.1808L15.9391 22.8247L16.1037 21.9144L16.3055 20.9257L16.3541 20.7057L15.6246 20.7088L14.4253 20.7296L13.3412 20.7554L12.5209 24.4614L12.5227 24.4757L12.5131 24.5005L12.4219 24.6497L12.3772 24.7201L12.2521 24.8004L12.1715 24.835C12.1501 24.8428 12.1312 24.8472 12.1061 24.8492L12.0034 24.8492L11.6941 24.8325L10.949 24.7728L10.1271 24.6994L9.60691 24.651L10.4524 20.6706L10.0113 20.6844L9.10814 20.6975L8.86068 20.6945C8.38041 20.681 8.24532 20.6184 8.10557 20.4318C7.84666 20.0861 8.08037 18.4494 8.62727 18.2624L8.77659 18.2471L10.9895 18.1581L11.3339 16.6626L11.7259 14.9968L10.3092 15.0169L9.86532 15.0165L9.63797 15.0113L9.45582 15.0009C9.42877 14.9987 9.40326 14.9962 9.37912 14.9935L9.24928 14.9737C9.15246 14.9543 9.08119 14.9272 9.01395 14.89C8.57232 14.5755 8.94682 12.5434 9.58415 12.5434L11.3793 12.48L12.0049 12.4517L12.3381 12.4328L13.3916 7.4132L13.4668 7.32942C13.5889 7.19356 13.7944 7.12525 14.1709 7.08032L14.4483 7.05333L14.7821 7.03036L15.1462 7.01086L15.4734 7.00051L15.7554 7ZM17.6074 14.9214L14.6888 14.9137L14.3248 16.4566L14.0534 17.6702L13.9794 18.0278L16.9567 18.0115L17.0883 17.4542L17.2968 16.476L17.4957 15.4932L17.6074 14.9214Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Street")} *</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="street"
                      />
                      <svg className="w7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-location">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <label className="flex flex-col" htmlFor="">
                    <div className="p-2 fw-500">{t("Rent.Address addition")}</div>
                    <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                      <input
                        className="w-full h-full font-light outline-none"
                        type="text" name="address"
                      />
                      <svg className="w7 h-7" width="32" height="32">
                        <svg viewBox="0 0 32 32" fill="none" id="icon-location">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </div>
                    <div className="px-4 py-1 xl:h-6 font-light"></div>
                  </label>

                  <div className="grid gap-4 grid-cols-3">
                    <label htmlFor="" className="flex flex-col">
                      <div className="p-2 fw-500">{t("Rent.Zip")} *</div>
                      <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                        <input
                          className="w-full h-full font-light outline-none"
                          type="text" name="zip"
                        />
                        <svg className="w7 h-7" width="32" height="32">
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-location"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>
                      </div>
                      <div className="px-4 py-1 xl:h-6 font-light"></div>
                    </label>

                    <label className="flex flex-col col-span-2" htmlFor="">
                      <div className="p-2 fw-500">{t("Rent.City")} *</div>
                      <div className="relative flex items-center justify-around px-4 py-2 min-h-[theme(spacing.11)] bg-white border focus-within:border-primary rounded-xl hover:shadow border-transparent">
                        <input
                          className="w-full h-full font-light outline-none"
                          type="text" name="city"
                        />
                        <svg className="w7 h-7" width="32" height="32">
                          <svg
                            viewBox="0 0 32 32"
                            fill="none"
                            id="icon-location"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M16 5C20.6947 5 24.5 8.88394 24.5 13.6749C24.5 19.8381 17.0614 25.7247 16.1016 26.4586L16.026 26.5159C16.0088 26.5288 16 26.5353 16 26.5353C16 26.5353 15.9912 26.5288 15.974 26.5159L15.8984 26.4586C14.9386 25.7247 7.5 19.8381 7.5 13.6749C7.5 8.88394 11.3053 5 16 5ZM16 8.60808C13.392 8.60808 11.2778 10.7223 11.2778 13.3303C11.2778 15.9383 13.392 18.0525 16 18.0525C18.608 18.0525 20.7222 15.9383 20.7222 13.3303C20.7222 10.7223 18.608 8.60808 16 8.60808Z"
                              fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                            ></path>
                          </svg>
                        </svg>
                      </div>
                    </label>
                  </div>

                  <div className="country-flag-wrapper mb-5">
                    <label className="flex flex-col" htmlFor="">
                      <div className="p-2 fw-500">{t("Rent.Country")}</div>

                      <ReactFlagsSelect
                        countries={CountriesLabels}
                        customLabels={i18n.resolvedLanguage === 'de' ? Germancountries : countries}
                        showOptionLabel={true}
                        selected={selectedConutry}
                        onSelect={(code) => setSelectedCountry(code)}
                        className="flag-container flex items-center justify-around px-4 py-2 h-11 bg-white focus-within:border focus-within:border-primary rounded-t-xl hover:shadow rounded-b-xl"
                        selectButtonClassName="w7 h-7"
                        id="icon-location"
                        searchable

                      />

                    </label>

                  </div>
                  {error ? <p style={{ color: "red" }} className="mb-2 flex w-full animate-wiggle items-center justify-between rounded bg-warning px-4 py-2 text-lg text-white">{error}</p> : ''}
                  <div className="mt-2 fw-500">*{t("Rent.Required field")}</div>
                  <label className="flex items-center">
                    <div className="mr-4 w-7 h-7">
                      <input id="newsletter" type="checkbox" hidden="" name="currentInformation" className="peer custom-checkbox-input" />
                      <label htmlFor="" className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"></label>
                      <svg className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full" width="32" height="32"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-check"><path fillRule="evenodd" clipRule="evenodd" d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z" fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"></path></svg></svg>
                    </div>
                    <span className="fw-500">{t("Rent.Yes, I would like to receive current information")} {t("Rent.offers about camping")}</span>
                  </label>
                  {
                    termcheck === false ?
                      <label className="group flex items-center mt-4" htmlFor="">
                        <div className="w-7 h-7">
                          <input
                            id="checkbox-terms"
                            type="checkbox"
                            hidden=""
                            name="terms"
                            onChange={() => settermcheck(termcheck ? false : true)}
                            checked={termcheck}
                            required
                            className="peer custom-checkbox-input"
                          />
                          <label
                            htmlFor="checkbox-terms"
                            className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"
                          ></label>
                          <svg
                            className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full"
                            width="32"
                            height="32"
                          >
                            <svg viewBox="0 0 32 32" fill="none" id="icon-check">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                        </div>
                        <div className="ml-4 font-size-reduce-mobile">
                          <span>{t("Rent.I have read and agree to the")} </span>
                          <Link to="/privacystatement" className="underline">{t("Rent.Privacy Policy")}</Link>
                          <span> {t("Rent.and the")} </span>
                          <Link to="/gtc" className="underline d-block-mobile">{t("Rent.Terms and Conditions")}</Link>
                          &nbsp;
                          <span>{t("Rent.conditions")}</span>
                        </div>
                      </label>
                      :
                      <label className="group flex items-center mt-4" htmlFor="">
                        <div className="w-7 h-7">
                          <input
                            id="checkbox-terms"
                            type="checkbox"
                            hidden=""
                            name="terms"
                            onChange={() => settermcheck(termcheck ? false : true)}
                            checked={termcheck}

                            className="peer custom-checkbox-input"
                          />
                          <label
                            htmlFor="checkbox-terms"
                            className="peer-checked:hidden inline-block w-7 h-7 border border-secondary group-hover:border-primary border-opacity-disabled rounded-full"
                          ></label>
                          <svg
                            className="peer-checked:block hidden w-7 h-7 cssvar-secondary-to-white bg-primary rounded-full"
                            width="32"
                            height="32"
                          >
                            <svg viewBox="0 0 32 32" fill="none" id="icon-check">
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M21.906 9.48846L13.359 19.0475L9.90893 15.9522C9.14392 15.2659 7.99291 15.3597 7.34557 16.1608C6.70507 16.9533 6.79855 18.1407 7.55541 18.8197L12.3198 23.0941C13.0547 23.7534 14.1534 23.6963 14.8159 22.9643L24.5455 12.0952C25.2268 11.3424 25.1965 10.1517 24.4772 9.42988C23.7501 8.70042 22.5956 8.72641 21.906 9.48846Z"
                                fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                              ></path>
                            </svg>
                          </svg>
                        </div>
                        <div className="ml-4 font-size-reduce-mobile">
                          <span>{t("Rent.I have read and agree to the")} </span>
                          <Link to="/privacystatement" className="underline">{t("Rent.Privacy Policy")}</Link>
                          <span> {t("Rent.and the")} </span>
                          <Link to="/gtc" className="underline d-block-mobile">{t("Rent.Terms and Conditions")}</Link>
                          &nbsp;
                          <span>{t("Rent.conditions")}</span>
                        </div>
                      </label>
                  }

                  <button
                    type="submit"
                    className="mt-5 grid-cols1 inline-grid grid-rows-1 text-white bg-secondary hover:bg-primary pl-5 pr-2 w-full h-12 rounded bg-primary hover:bg-secondary transition-all btn btn-primary"
                  >
                    <span className="relative flex col-start-1 row-start-1 items-center justify-between w-full h-full transition-opacity duration-300">
                      <span className="transform transition-transform duration-300 translate-x-0">
                        <span >{t("Rent.Continue to Payment")}</span>
                      </span>
                      <svg
                        className="w-7 h-7 cssvar-secondary-to-white pointer-events-none"
                        width="32"
                        height="32"
                      >
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          id="icon-chevron-right"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M22.1256 15.9999L14.479 8.35332C14.009 7.88273 13.2445 7.88213 12.7739 8.35211L12.3532 8.77342C11.8809 9.24581 11.8833 10.0073 12.3544 10.4785L17.8759 15.9999L12.3544 21.5219C11.8833 21.9925 11.8809 22.7546 12.3532 23.2264L12.7739 23.6477C13.2445 24.1182 14.009 24.117 14.479 23.6465L22.1256 15.9999Z"
                            fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                          ></path>
                        </svg>
                      </svg>
                    </span>
                  </button>
                </TabPanel>


              </Tabs>
            </form>

            {/* <div className="absolute left-0 top-0 hidden w-full h-20 pointer-events-none md:block">
              <div className="relative mx-auto max-w-7xl h-full">
                <Link
                  to={"/camperconfiguration"}
                  className="absolute -bottom-10 left-0 flex items-center px-4 pointer-events-auto"
                >
                  <svg className="w-6 h-6" width="32" height="32">
                    <svg viewBox="0 0 32 32" fill="none" id="icon-chevron-left">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.87444 15.9999L17.521 8.35332C17.991 7.88273 18.7555 7.88213 19.2261 8.35211L19.6468 8.77342C20.1191 9.24581 20.1167 10.0073 19.6456 10.4785L14.1241 15.9999L19.6456 21.5219C20.1167 21.9925 20.1191 22.7546 19.6468 23.2264L19.2261 23.6477C18.7555 24.1182 17.991 24.117 17.521 23.6465L9.87444 15.9999Z"
                        fill="var(--svg-custom-color, var(--svg-color-secondary, #163435))"
                      ></path>
                    </svg>
                  </svg>
                  <div className="fw-500">Back</div>
                </Link>
              </div>
            </div> */}
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};
export default VoucherCheckout;
